import * as React from 'react';
import VodCollectionList from 'views/programming/mainCategories/edit/vodCollectionList/VodCollectionList';
import {useLazyFindVodCollectionQuery} from 'features/mainCategories/mainCategoriesApi';
import useSearch from 'components/mainCategoriesList/hooks/useSearch';
import {VodCollectionSearchLazyLoadProvider} from 'views/programming/mainCategories/edit/vodCollectionList/providers/VodCollectionSearchLazyProvider';
import {IVodCollection} from 'models/vodCollections';
import {IMainCategoryVODCollectionSearch} from 'models/mainCategories';

export default (): React.ReactElement => {
  return (
    <VodCollectionSearchLazyLoadProvider
      useProvider={() =>
        useSearch<IVodCollection, Partial<IMainCategoryVODCollectionSearch>>(useLazyFindVodCollectionQuery as any)
      }
    >
      <VodCollectionList />
    </VodCollectionSearchLazyLoadProvider>
  );
};
